// From https://github.com/bjoerge/debounce-promise/blob/master/index.js
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function debouncePromise(fn, wait, options) {
    if (wait === void 0) { wait = 0; }
    if (options === void 0) { options = {
        leading: false,
        accumulate: false
    }; }
    var lastCallAt;
    var deferred;
    var timer;
    var pendingArgs = [];
    return function debounced() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var currentWait = wait;
        var currentTime = new Date().getTime();
        var isCold = !lastCallAt || currentTime - lastCallAt > currentWait;
        lastCallAt = currentTime;
        if (isCold && options.leading) {
            return options.accumulate
                ? Promise.resolve(fn.call(this, [args])).then(function (result) { return result[0]; })
                : Promise.resolve(fn.call.apply(fn, __spreadArray([this], __read(args), false)));
        }
        if (deferred) {
            clearTimeout(timer);
        }
        else {
            deferred = defer();
        }
        pendingArgs.push(args);
        timer = setTimeout(flush.bind(this), currentWait);
        if (options.accumulate) {
            var argsIndex_1 = pendingArgs.length - 1;
            return deferred.promise.then(function (results) { return results[argsIndex_1]; });
        }
        return deferred.promise;
    };
    function flush() {
        var thisDeferred = deferred;
        if (!thisDeferred)
            return;
        clearTimeout(timer);
        Promise.resolve(options.accumulate ? fn.call(this, pendingArgs) : fn.apply(this, pendingArgs[pendingArgs.length - 1])).then(thisDeferred.resolve, thisDeferred.reject);
        pendingArgs = [];
        deferred = null;
    }
}
function defer() {
    var deferredResolve;
    var deferredReject;
    var promise = new Promise(function (resolve, reject) {
        deferredResolve = resolve;
        deferredReject = reject;
    });
    return {
        promise: promise,
        resolve: deferredResolve,
        reject: deferredReject
    };
}
